import { useEffect, ReactNode } from "react"
import { useForm, FormProvider } from "react-hook-form"
import { each } from "lodash"

interface FormProps {
  onSubmit: (data: any) => void
  children: ReactNode
  defaultValues?: Record<string, any>
  errors?: Record<string, string[]>
  className?: string
}

const Form = ({
  defaultValues,
  errors = {},
  children,
  onSubmit,
  ...props
}: FormProps) => {
  const methods = useForm({ defaultValues })

  useEffect(() => {
    each(errors, (errors, field) => {
      errors.forEach((error) => {
        methods.setError(field, { type: "server", message: error })
      })
    })
  }, [errors])

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} {...props}>
        {children}
      </form>
    </FormProvider>
  )
}

export default Form
